import { SOURCE } from "components/containers/InspectionFormat/Content/SettingPinLayoutFrame/context/pinLayoutFrameReducer";
import { CheckboxExtraKey } from "components/containers/inspectionSetting/containers/templateBuilder/fields/checkbox/draggable";
import { InspectionItemResult } from "interfaces/models/inspectionItemResult";
import { BORDER_WIDTH_PX } from "interfaces/models/pinComponent";
import { PinLayoutDTO } from "interfaces/models/pinLayout";
import { arrayToObject } from "utils/object";

const FULL_SIZE_PERCENT = 100;

export const repeatPinFrames = (params: {
  pinLayout: PinLayoutDTO;
  itemResults: InspectionItemResult[];
  pageWidth: number;
  pageHeight: number;
}) => {
  const { pinLayout, itemResults, pageWidth, pageHeight } = params;
  const {
    numberRepeatY = 1,
    numberRepeatX = 1,
    paddingX: _paddingX = 0,
    paddingY: _paddingY = 0,
  } = pinLayout?.data || {};
  if (!pinLayout) {
    return [];
  }

  // convert pinLayout width (%), height (%) to px
  const pinLayoutWidth = (Number(pinLayout.width) * Number(pageWidth)) / 100;
  const pinLayoutHeight = (Number(pinLayout.height) * Number(pageHeight)) / 100;

  // Filter out components of type inspectionForm that are not in the resultItem
  const mapInspectionItemResult = arrayToObject(itemResults, "id");
  const pinFrames = (pinLayout?.pinFrames || []).filter((component) => {
    if (component.linkedData?.source === SOURCE.INSPECTION_FORM) {
      return mapInspectionItemResult?.[component.linkedData.key];
    }

    return true;
  });

  const offsetHeightPercent = BORDER_WIDTH_PX / Number(pinLayoutHeight);
  const offsetWidthPercent = BORDER_WIDTH_PX / Number(pinLayoutWidth);

  const pinComponents: any[] = [];
  let paddingX = (Number(_paddingX || 0) / pinLayoutHeight) * FULL_SIZE_PERCENT;
  let paddingY = (Number(_paddingY || 0) / pinLayoutWidth) * FULL_SIZE_PERCENT;
  if (paddingX) {
    paddingX = paddingX + offsetHeightPercent * 2;
  }
  if (paddingY) {
    paddingY = paddingY + offsetWidthPercent * 2;
  }
  const offsetTop = FULL_SIZE_PERCENT + paddingX + offsetHeightPercent;
  const offsetLeft = FULL_SIZE_PERCENT + paddingY + offsetWidthPercent;

  // repeat by vertical
  new Array(numberRepeatX).fill(0).forEach((_, indexX) => {
    const currentOffsetTop = offsetTop * indexX;
    const pinComponent = pinFrames.map((component) => {
      return {
        isRepeat: !!indexX,
        offsetTop: currentOffsetTop,
        offsetLeft: 0,
        component,
      };
    });

    pinComponents.push(pinComponent);

    // repeat by horizontal
    new Array(numberRepeatY - 1).fill(0).forEach((_, indexY) => {
      const currentOffsetLeft = offsetLeft * (indexY + 1);
      const pinComponent = pinFrames.map((component) => {
        return {
          isRepeat: true,
          offsetTop: currentOffsetTop,
          offsetLeft: currentOffsetLeft,
          component,
        };
      });

      pinComponents.push(pinComponent);
    });
  });

  return pinComponents;
};

export const transformCheckboxExtraKey = (
  linkedDataExtraId: number | string | undefined
) => {
  const extraIdStr = linkedDataExtraId?.toString() || "";
  const re = new RegExp(
    `_${CheckboxExtraKey.VALUE}|_${CheckboxExtraKey.LABEL}`,
    "g"
  );

  const extraId = extraIdStr.replace(re, "");
  const isCheckboxValue = extraIdStr.includes(`_${CheckboxExtraKey.VALUE}`);
  const isCheckboxLabel = extraIdStr.includes(`_${CheckboxExtraKey.LABEL}`);
  const normalizeCheckboxValue = `${extraId}_${CheckboxExtraKey.VALUE}`;
  const normalizeCheckboxLabel = `${extraId}_${CheckboxExtraKey.LABEL}`;

  return {
    isCheckboxLabel,
    isCheckboxValue,
    extraId,
    normalizeCheckboxValue,
    normalizeCheckboxLabel,
  };
};
